var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import Quill from "quill";
const BlockEmbed = Quill.import("blots/block/embed");
const DEFAULT = {
  cssText: "border: none;border-bottom: 1px inset;",
  className: void 0,
  icon: '<svg class="icon" style="vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path class="ql-fill" d="M64 464h896v96H64v-96zM224 96v160h576V96h96v256H128V96h96z m576 832v-160H224v160H128v-256h768v256h-96z"></path></svg>'
};
class Divider extends BlockEmbed {
  static create(options) {
    const parentNode = super.create();
    parentNode.setAttribute("contenteditable", false);
    if (options.text) {
      const width = ["100%", "100%"];
      if (options.text.orientation === "left") {
        width[0] = 0;
      }
      if (options.text.orientation === "right") {
        width[1] = 0;
      }
      const commonStyle = "position: relative;top: 50%;transform: translateY(-50%);";
      const lineLeft = `<span contenteditable="false" style="width: ${width[0]};${commonStyle}${options.cssText || ""}" class="${options.className || ""}" ></span>`;
      const lineRight = `<span contenteditable="false" style="width: ${width[1]};${commonStyle}${options.cssText || ""}" class="${options.className || ""}" ></span>`;
      parentNode.style.display = "flex";
      parentNode.style.textAlign = "center";
      parentNode.innerHTML = `${lineLeft}<span style="display: inline-block;${options.text.childrenStyle}" contenteditable="true">${options.text.children || "placeholder"}</span>${lineRight}`;
    } else {
      parentNode.innerHTML = `<hr style="${options.cssText}" class="${options.className || ""}" >`;
    }
    return parentNode;
  }
}
Divider.blotName = "divider";
Divider.tagName = "div";
Divider.className = "quill-hr";
const Module = Quill.import("core/module");
class DividerToolbar extends Module {
  constructor(quill, options) {
    super(quill, options);
    __publicField(this, "quill");
    __publicField(this, "options");
    this.options = Object.assign({}, DEFAULT, options);
    this.quill = quill;
    this.toolbar = quill.getModule("toolbar");
    this.toolbar.addHandler("divider", this.dividerHandler.bind(this));
    const divider2 = document.querySelector(".ql-divider");
    if (divider2) {
      divider2.innerHTML = this.options.icon;
    }
  }
  dividerHandler() {
    var _a, _b;
    const getSelection = this.quill.getSelection() || { index: 0, length: 0 };
    const content = ((_a = this.quill.getContents(getSelection.index, getSelection.length)) == null ? void 0 : _a.ops) || [];
    let selection = getSelection.index || this.quill.getLength();
    const [leaf] = this.quill.getLeaf(selection - 1);
    if (leaf instanceof Divider) {
      this.quill.insertText(selection, "\n", Quill.sources.USER);
      selection++;
    }
    if (this.options.text) {
      this.quill.deleteText(getSelection.index, getSelection.length);
      this.options.text.children = typeof ((_b = content[0]) == null ? void 0 : _b.insert) === "string" ? content[0].insert : "placeholder";
    }
    this.quill.insertEmbed(selection, "divider", this.options, Quill.sources.USER);
    if (getSelection.index === 0) {
      selection++;
      this.quill.insertText(selection, "\n", Quill.sources.USER);
    }
    this.quill.setSelection(selection + 2, 0);
  }
}
Quill.register(Divider);
Quill.register("modules/divider", DividerToolbar);
export { DividerToolbar as default };
